import { ReactElement } from 'react';

import {
   ReceptionServiceWithPractitioners,
   ReceptionServiceWithPractitionersQuery,
   ReceptionServiceWithPractitionersSimpleQuery,
} from '@dreryk/egabinet-private-medical-service-frontend-api';
import { PractitionerId } from '@dreryk/egabinet-personnel-published-language-api';
import { ReceptionServiceId } from '@dreryk/egabinet-private-medical-service-published-language-api';
import { ServiceLocationId } from '@dreryk/egabinet-healthcare-provider-published-language-api';

import { useCqrsExists, useCqrsGet } from '@dreryk/command-query-react-common';
import { Slot } from '@dreryk/watermelon';
import { LoaderSpinner } from '@dreryk/react-components';

type ServiceFieldLoaderChildrenRenderProps = {
   servicesExist: boolean | undefined;
   currentServiceLocationIds: ServiceLocationId[];
};

type ServiceFieldLoaderProps = {
   practitionerId: number | undefined;
   currentServiceId: ReceptionServiceId | undefined;
   children: (renderProps: ServiceFieldLoaderChildrenRenderProps) => ReactElement;
};

export const ServiceFieldLoader = (props: ServiceFieldLoaderProps): ReactElement => {
   const { data: servicesExist, loading: serviceExistLoading } = useCqrsExists(
      () => {
         const query = new ReceptionServiceWithPractitionersSimpleQuery();
         query.practitionersIds = Slot.emptyIfNull(
            props.practitionerId ? [PractitionerId.of(props.practitionerId)] : null
         );
         return query;
      },
      {
         enabled: Boolean(props.practitionerId),
      }
   );
   const { data: currentService } = useCqrsGet<ReceptionServiceWithPractitioners>(
      () => {
         const query = new ReceptionServiceWithPractitionersQuery();
         query.id = props.currentServiceId!;
         return query;
      },
      {
         enabled: Boolean(props.currentServiceId),
      }
   );

   if (serviceExistLoading) {
      return <LoaderSpinner />;
   }

   return props.children({
      servicesExist: servicesExist,
      currentServiceLocationIds: currentService?.serviceLocationIds ?? [],
   });
};
